// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2mFcG","additionalInfo":"AgreementModal_additionalInfo__2rCaZ"};